module.exports = __webpack_public_path__ + "img/zhiboBack.7233d8c6.png";